import { i18n } from './../../../i18n';

export type LangTypes =
  | 'en'
  | 'ja'
  | 'zh'
  | 'es'
  | 'fr'
  | 'de'
  | 'ru'
  | 'it'
  | 'ko'
  | 'tr'
  | 'th'
  | 'vi'
  | 'id'
  | 'ms'
  | 'ar'
  | 'pt'
  | 'pl-PL'
  | 'sv-SE'
  | 'cs-CZ';

const defaultFallbackLocale: LangTypes = 'en';

// 子应用多语言到business多语言的映射
const LOCALES = '@byted/wc-business-ui/locales';
export const Locale2WcUiLangMap: Record<LangTypes, Promise<any>> = {
  en: import(`@byted/wc-business-ui/locales/en-GB`),
  ja: import(`@byted/wc-business-ui/locales/ja-JP`),
  zh: import(`@byted/wc-business-ui/locales/zh-CN`),
  es: import(`@byted/wc-business-ui/locales/es-ES`),
  fr: import(`@byted/wc-business-ui/locales/fr-FR`),
  de: import(`@byted/wc-business-ui/locales/de-DE`),
  ru: import(`@byted/wc-business-ui/locales/ru-RU`),
  it: import(`@byted/wc-business-ui/locales/it-IT`),
  ko: import(`@byted/wc-business-ui/locales/ko-KR`),
  tr: import(`@byted/wc-business-ui/locales/tr-TR`),
  th: import(`@byted/wc-business-ui/locales/th-TH`),
  vi: import(`@byted/wc-business-ui/locales/vi-VN`),
  id: import(`@byted/wc-business-ui/locales/id-ID`),
  ms: import(`@byted/wc-business-ui/locales/ms-MY`),
  ar: import(`@byted/wc-business-ui/locales/ar`),
  pt: import(`@byted/wc-business-ui/locales/pt-BR`),
  'pl-PL': import(`@byted/wc-business-ui/locales/pl-PL`),
  'sv-SE': import(`@byted/wc-business-ui/locales/sv-SE`),
  'cs-CZ': import(`@byted/wc-business-ui/locales/cs-CZ`),
};

export const getWcLocalesPromiseArr = (lang: LangTypes = defaultFallbackLocale) => [Locale2WcUiLangMap[lang]];

/**
 * 判断是否是 RTL 语言
 * @returns {Boolean}
 */
const rtlLanguageList: LangTypes[] = ['ar'];
export const isRTLLangue = (): boolean => rtlLanguageList.includes(i18n.locale as LangTypes);
